module.exports = __webpack_public_path__ + "stylesheets/font-ko_7d0d1bf91b94a34aa300d1e3bc2470e4.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/fonts/font-ko.less
// module id = fbuv
// module chunks = 55 56